import { useState } from 'react';
import './CustomInput.css';

function CustomInput(props:{
    id: string,
    name: string,
    min?: number,
    max?: number,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}){
    const [warning, setWarning] = useState(false);

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value, 10);

        if (isNaN(value) || (props.min !== undefined && value < props.min) || (props.max !== undefined && value > props.max)) {
            setWarning(true);
        } else {
            setWarning(false);
        }
    };

    return (
        <div className='input-div-container'>
            <label className='input-label' htmlFor={props.id}>{props.name}</label>
            <div className='input-div'>
                <input 
                    id={props.id} 
                    className='input' 
                    type='number' 
                    inputMode='numeric' 
                    min={props.min} 
                    max={props.max} 
                    required pattern="[0-9]*" 
                    onChange={props.onChange} 
                    onBlur={handleBlur}    
                />
                {warning && (
                    <p className="error-text">
                        მნიშვნელობა უნდა იყოს {props.min} და {props.max} შორის
                    </p>
                )}
            </div>
        </div>
    )
}

export default CustomInput;